import { Money } from '@/components';

/** Price / tax / shipping breakdown (WEB-05). `t` is a cartTotals() result. */
export default function PriceSummary({ t, couponCode, shippingLabel }) {
  const Row = ({ label, children, strong }) => (
    <div className={`flex justify-between gap-4 ${strong ? 'text-base font-bold' : ''}`}>
      <dt className={strong ? '' : 'opacity-70'}>{label}</dt>
      <dd className="text-right">{children}</dd>
    </div>
  );
  return (
    <div className="space-y-2 text-sm">
      <dl className="space-y-1.5">
        <Row label={`MRP (${t.count} item${t.count === 1 ? '' : 's'})`}><Money paise={t.mrp_paise} /></Row>
        {t.item_savings_paise ? <Row label="Refurbished discount"><span className="text-success-700">− <Money paise={t.item_savings_paise} /></span></Row> : null}
        <Row label="Subtotal"><Money paise={t.subtotal_paise} /></Row>
        {t.coupon_paise ? <Row label={`Coupon ${couponCode || ''}`.trim()}><span className="text-success-700">− <Money paise={t.coupon_paise} /></span></Row> : null}
        <Row label={shippingLabel || 'Delivery'}>{t.shipping_paise ? <Money paise={t.shipping_paise} /> : <span className="text-success-700">Free</span>}</Row>
        <div className="border-t border-[var(--app-border)] pt-2">
          <Row label="Total" strong><Money paise={t.total_paise} /></Row>
        </div>
        <Row label="Includes GST (18%)"><Money paise={t.gst_included_paise} /></Row>
      </dl>
      {t.you_save_paise > 0 ? (
        <p className="rounded-md bg-success-50 px-3 py-2 text-success-800">You save <Money paise={t.you_save_paise} /> on this order</p>
      ) : null}
    </div>
  );
}
